import { default as api } from "../../util/api";
import { FEATURE_MANAGEMENT_URL } from "../../util/constants/api.constants";

export interface FeatureFlagDto {
  FeatureName: string;
  IsEnabled: boolean;
  /** True for Timer/Queue (background) features. */
  IsBackground?: boolean;
  Permission: string;
  CanAdd: boolean;
  CanUpdate: boolean;
  CanSave: boolean;
  CanEdit: boolean;
  CanDelete: boolean;
  CanImport: boolean;
}

export interface FeaturePermissionResponse {
  UserEmail: string;
  IsAdmin: boolean;
  Permission: string;
  Features: FeatureFlagDto[];
}

export function getFeatures(): Promise<FeaturePermissionResponse> {
  return api.get(FEATURE_MANAGEMENT_URL.GET_FEATURES, {});
}

export function updateFeature(
  featureName: string,
  isEnabled: boolean
): Promise<FeaturePermissionResponse> {
  return api.put(FEATURE_MANAGEMENT_URL.UPDATE_FEATURE, {
    FeatureName: featureName,
    IsEnabled: isEnabled,
  });
}

export interface UserFeaturePermissionDto {
  Id: number;
  UserEmail: string;
  FeatureName: string;
  Permission: string;
  IsFeatureEnabled: boolean;
  CreatedBy: string;
  CreatedDate: string;
}

export interface UserFeaturePermissionResponse {
  Permissions: UserFeaturePermissionDto[];
  /** Enabled, non Timer/Queue features that can be granted. */
  AssignableFeatures: string[];
}

export function getUserPermissions(): Promise<UserFeaturePermissionResponse> {
  return api.get(FEATURE_MANAGEMENT_URL.USER_PERMISSIONS, {});
}

export function assignUserPermissions(
  userEmail: string,
  featureNames: string[]
): Promise<UserFeaturePermissionResponse> {
  return api.post(FEATURE_MANAGEMENT_URL.USER_PERMISSIONS, {
    UserEmail: userEmail,
    FeatureNames: featureNames,
  });
}

export function removeUserPermission(
  id: number
): Promise<UserFeaturePermissionResponse> {
  return api.delete(`${FEATURE_MANAGEMENT_URL.USER_PERMISSIONS}/${id}`);
}
